import type { ProductListItemDTO } from "../../../api/productList"

export type TechnologyInputSubstituteDraft = {
  product: ProductListItemDTO | undefined
  qty: string
  loss_percent: string
  service_cost_netto: string
  priority: string
  note: string
}

type InputWithSubstitutes = {
  substitutes?: TechnologyInputSubstituteDraft[]
}

export function updateSubstituteLossPercent<T extends InputWithSubstitutes>(
  inputs: T[],
  inputIndex: number,
  substituteIndex: number,
  lossPercent: string,
): T[] {
  const next = [...inputs]
  const substitutes = [...(next[inputIndex]?.substitutes ?? [])]
  const substitute = substitutes[substituteIndex]
  if (!substitute) return next

  substitutes[substituteIndex] = {
    ...substitute,
    loss_percent: lossPercent,
  }
  next[inputIndex] = { ...next[inputIndex], substitutes }
  return next
}
